import type { RunStatus, AgentStatus, PlatformStatus } from '@/types'

type Status = RunStatus | AgentStatus | PlatformStatus | 'ok' | 'error' | 'alert'

const STATUS_COLOR: Record<string, string> = {
  active: 'var(--status-success)',
  ok: 'var(--status-success)',
  completed: 'var(--status-success)',
  running: 'var(--status-hitl)',
  queued: 'var(--text-tertiary)',
  planning: 'var(--text-tertiary)',
  planned: 'var(--text-tertiary)',
  waiting_hitl: 'var(--status-warning)',
  alert: 'var(--status-warning)',
  paused: 'var(--status-warning)',
  inactive: 'var(--text-tertiary)',
  failed: 'var(--status-error)',
  error: 'var(--status-error)',
  timed_out: 'var(--status-error)',
  deprecated: 'var(--status-error)',
}

const STATUS_LABEL: Record<string, string> = {
  active: 'Activo',
  ok: 'OK',
  completed: 'Completado',
  running: 'Corriendo',
  queued: 'En cola',
  planning: 'Planeando',
  planned: 'Planeado',
  waiting_hitl: 'Espera aprobación',
  alert: 'Alerta',
  paused: 'Pausado',
  inactive: 'Inactivo',
  failed: 'Falló',
  error: 'Error',
  timed_out: 'Timeout',
  deprecated: 'Descontinuado',
}

export function StatusDot({ status, showLabel = true }: { status: Status; showLabel?: boolean }) {
  const color = STATUS_COLOR[status] ?? 'var(--text-tertiary)'
  const label = STATUS_LABEL[status] ?? status
  const isPulsing = status === 'running'

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span
        aria-hidden
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: color,
          flexShrink: 0,
          animation: isPulsing ? 'status-pulse 1.6s ease-in-out infinite' : undefined,
        }}
      />
      {showLabel && (
        <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{label}</span>
      )}
      <style>{`
        @keyframes status-pulse {
          0%, 100% { opacity: 1; box-shadow: 0 0 0 0 ${color}66; }
          50% { opacity: 0.6; box-shadow: 0 0 0 4px transparent; }
        }
      `}</style>
    </span>
  )
}
